import { render } from "./index.vue?vue&type=template&id=6f097ef5&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=6f097ef5&lang=scss&scoped=true"

import exportComponent from "G:\\web2\\豪哥\\九皇仙府\\admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f097ef5"]])

export default __exports__